export default "__VITE_ASSET__zneYFHXI__"